// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HouseholdValidationStatusSubscriptionVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type HouseholdValidationStatusSubscription = { __typename?: 'Subscription', household: { __typename?: 'Household', id: string, hasPendingValidationQuestions: boolean } };

export const Operations = {
  Subscription: {
    HouseholdValidationStatus: 'HouseholdValidationStatus' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const HouseholdValidationStatusDocument = gql`
    subscription HouseholdValidationStatus($householdId: ID!) {
  household(id: $householdId) {
    id
    hasPendingValidationQuestions
  }
}
    `;

/**
 * __useHouseholdValidationStatusSubscription__
 *
 * To run a query within a React component, call `useHouseholdValidationStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdValidationStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdValidationStatusSubscription({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useHouseholdValidationStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<HouseholdValidationStatusSubscription, HouseholdValidationStatusSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HouseholdValidationStatusSubscription, HouseholdValidationStatusSubscriptionVariables>(HouseholdValidationStatusDocument, withSubscriptionIgnoreResults(options));
      }
export type HouseholdValidationStatusSubscriptionHookResult = ReturnType<typeof useHouseholdValidationStatusSubscription>;
export type HouseholdValidationStatusSubscriptionResult = Apollo.SubscriptionResult<HouseholdValidationStatusSubscription>;